<form
    ng-form="fieldRecordLodgementForm"
    class="well">
    <h5>Lodgement</h5>

    <div class="row">
        <div class="col-xs-6">
            <label class="control-label required-input">Lodge type</label>
            <div
                class="input-group"
                ng-class="{'has-error': fieldRecordLodgementForm.lodgeType.$invalid
                    && (fieldRecordLodgementForm.lodgeType.$dirty || fieldRecordLodgementForm.$submitted)}">
                <ng-select
                    class="nlr-ng-select"
                    #lodgeType="ngModel"
                    [searchable]="false"
                    [clearable]="false"
                    [ngClass]="{'has-error': !isLodgeTypeValid() && submitted}"
                    name="lodgeType"
                    id="lodgeType"
                    placeholder="Select"
                    [items]="lodgeTypes"
                    bindLabel="name"
                    bindValue="id"
                    [ngModel]="model.lodgeType"
                    (ngModelChange)="updateSelectedOption($event)"
                    required>
                </ng-select>
            </div>
        </div>
        @if (getAmendmentDetailsLabel()) {
            <div class="col-xs-6">
                <label class="control-label required-input">{{getAmendmentDetailsLabel()}}</label>
                <div
                    class="input-group"
                    [ngClass]="{'has-error': isAmendmentDetailsInValid()}">
                    <span class="input-group-addon corner">
                        <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                    </span>
                    <textarea
                        #amendmentDetails="ngModel"
                        class="form-control"
                        name="amendmentDetails"
                        id="amendmentDetails"
                        [(ngModel)]="model.amendmentDetails"
                        (ngModelChange)="onAmdDtlChange($event)"
                        rows="4"
                        cols="50"
                        maxlength="1024"
                        required></textarea>
                </div>
            </div>
        }
    </div>
    <div class="row">
        <div class="col-xs-6">
            <label class="control-label required-input">Lodgement receipt email address</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': lodgeEmailAddr.invalid && lodgeEmailAddr.dirty}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    #lodgeEmailAddr="ngModel"
                    type="email"
                    name="lodgementReceiptEmailAddress"
                    id="lodgementReceiptEmailAddress"
                    class="form-control"
                    [(ngModel)]="model.lodgementReceiptEmailAddress"
                    (ngModelChange)="onReceiptEmailChange($event)"
                    required />
            </div>
            @if (lodgeEmailAddr.invalid && lodgeEmailAddr.dirty) {
                <div class="help-block">
                    <span>Error!</span>
                    <span>Invalid</span>
                </div>
            }
        </div>
        <div class="col-xs-6">
            <label class="control-label">Customer reference</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': custReference.invalid && custReference.dirty}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    #custReference="ngModel"
                    type="text"
                    name="customerReference"
                    id="customerReference"
                    class="form-control"
                    [(ngModel)]="model.customerReference"
                    (ngModelChange)="onCustReferenceChange($event)" />
            </div>
        </div>
    </div>
</form>
